// @ts-nocheck
/* eslint-disable */
export const textIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="55" viewBox="0 0 30 55"><text id="T" transform="translate(0 44)" font-size="49" font-family="TimesNewRomanPSMT, Times New Roman">\r\n        <tspan x="0" y="0">T</tspan>\r\n    </text></svg>`,
    name: 'text' as const
};